import React from "react";
import { NavLink } from "react-router-dom";

const NavBar = () => {
  return (
    <ul className="nav flex-column">
      <li className="nav-item">
        <NavLink className="nav-link" to="/settings/account-settings">
          Account Settings
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink className="nav-link" to="/settings/my-gear">
          My Assets
        </NavLink>
      </li>
      <li className="nav-item">
        <a
          className="nav-link"
          href="https://aushare.sharepoint.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Company Intranet
        </a>
      </li>
      <li className="nav-item">
        <a
          className="nav-link"
          href="https://aushare.sharepoint.com/SitePages/Policies-and-Forms.aspx"
          target="_blank"
          rel="noopener noreferrer"
        >
          Company Documents
        </a>
      </li>
    </ul>
  );
};

export default NavBar;
